/* global NGX, NGXD */

// Import action types.
import ActionTypes from './actionTypes.js';

// Selectors.
import Selectors from './selectors.js';

// Config.
import Config from './config/config.js';
import Enums from './config/enums.js';

// Misc dependencies.
import { createUUID } from '../../common/utils/user';

import { AnalyticsEvents } from '../../common/config/api';

/**
 * <pre>
 * PrivacyManagement module Actions.
 *
 * Summary of responsibilities:
 *
 *  - implements Redux action creators specific to component
 *
 * FYI:
 *
 * We are using {@link https://github.com/gaearon/redux-thunk|Redux Thunk} middleware on our {@link https://github.com/reactjs/redux|Redux} store.
 * For this reason you will see that inside each action creator, we return a function, rather than an action object directly.
 * </pre>
 *
 * @see {@link https://github.com/gaearon/redux-thunk|Redux Thunk Documentation}
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}
 */
const Actions = {

  showPrivacyPopup: function() {
    return function(dispatch) {
      dispatch({
        type: ActionTypes.SHOW_PRIVACY_POPUP,
      });
    };
  },
  hidePrivacyPopup: function() {
    return function(dispatch) {
      dispatch({
        type: ActionTypes.HIDE_PRIVACY_POPUP,
      });
    };
  },

  showCookiesDisabledModal: function() {
    return function(dispatch) {
      dispatch({
        type: ActionTypes.SHOW_COOKIES_DISABLED_MODAL,
      });
    };
  },
  hideCookiesDisabledModal: function() {
    return function(dispatch) {
      dispatch({
        type: ActionTypes.HIDE_COOKIES_DISABLED_MODAL,
      });
    };
  },

};

export default Actions;